<template>
  <header class="progress-header">
    <button class="icon-button" type="button" aria-label="테스트 종료" @click="$emit('close')">×</button>
    <div class="progress-header__track" aria-hidden="true">
      <span :style="{ width: `${percentage}%` }" />
    </div>
    <span class="progress-header__count">{{ current }}/{{ total }}</span>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  current: number
  total: number
  tone?: 'orange' | 'green'
}>()

defineEmits<{
  close: []
}>()

const percentage = computed(() => {
  if (props.total <= 0) return 0
  return Math.min(100, Math.max(0, (props.current / props.total) * 100))
})
</script>
